module.exports = __webpack_public_path__ + "index/img/SmartFireCloudPlatform.f1ca97c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/SmartFireCloudPlatform.png
// module id = N7BR
// module chunks = 2